import {Icon} from '../Icon/Icon';
import {Button} from '../shadcn/button';
import {Tooltip, TooltipContent, TooltipProvider, TooltipTrigger} from '../shadcn/tooltip';

export type FileActionsBarSize = 'sm' | 'md';

export interface FileActionsBarProps {
  onPreview?: () => void;
  onDownload?: () => void;
  onDelete?: () => void;
  previewLabel?: string;
  downloadLabel?: string;
  deleteLabel?: string;
  isPreviewing?: boolean;
  isDownloading?: boolean;
  isDeleting?: boolean;
  disabled?: boolean;
  size?: FileActionsBarSize;
}

const sizeConfig = {
  sm: {button: 'icon-sm' as const, icon: 'size-4'},
  md: {button: 'icon' as const, icon: 'size-5'}
};

export function FileActionsBar({
  onPreview,
  onDownload,
  onDelete,
  previewLabel = 'Preview',
  downloadLabel = 'Download',
  deleteLabel = 'Delete',
  isPreviewing = false,
  isDownloading = false,
  isDeleting = false,
  disabled = false,
  size = 'sm'
}: FileActionsBarProps) {
  const isBusy = disabled || isPreviewing || isDownloading || isDeleting;
  const {button: buttonSize, icon: iconClass} = sizeConfig[size];
  const actions = [
    {onClick: onPreview, label: previewLabel, isLoading: isPreviewing, icon: 'view' as const},
    {
      onClick: onDownload,
      label: downloadLabel,
      isLoading: isDownloading,
      icon: 'download-cloud' as const
    },
    {onClick: onDelete, label: deleteLabel, isLoading: isDeleting, icon: 'delete' as const}
  ];

  return (
    <TooltipProvider>
      <div className="flex shrink-0 items-center gap-1">
        {actions.map(
          ({onClick, label, isLoading, icon}) =>
            onClick && (
              <Tooltip key={icon}>
                <TooltipTrigger
                  render={
                    <Button
                      variant="tertiary"
                      size={buttonSize}
                      onClick={onClick}
                      disabled={isBusy}
                      isLoading={isLoading}
                      icon={<Icon name={icon} className={iconClass} />}
                      aria-label={label}
                      className="hover:bg-transparent"
                    />
                  }
                />
                <TooltipContent>{label}</TooltipContent>
              </Tooltip>
            )
        )}
      </div>
    </TooltipProvider>
  );
}
